<template>
  <a-button
    :size="size"
    :type="type"
    v-clipboard:copy="text"
    v-clipboard:success="onCopySuccess"
    v-clipboard:error="onCopyError"
  >
    <a-icon type="copy" />
    <span v-if="showText">{{ buttonText }}</span>
  </a-button>
</template>

<script>
export default {
  name: 'CopyButton',
  props: {
    // 要复制的文本内容
    text: {
      type: String,
      required: true
    },
    // 按钮大小
    size: {
      type: String,
      default: 'small'
    },
    // 按钮类型
    type: {
      type: String,
      default: 'link'
    },
    // 是否显示文字
    showText: {
      type: Boolean,
      default: false
    },
    // 按钮文字
    buttonText: {
      type: String,
      default: '复制'
    }
  },
  methods: {
    onCopySuccess () {
      this.$message.success('复制成功')
      this.$emit('copy-success', this.text)
    },
    onCopyError () {
      this.$message.error('复制失败')
      this.$emit('copy-error')
    }
  }
}
</script>
